import React,{useContext} from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const ReportedIcon = (props) => {
  const { themeName, getThemeColor,getThemeColorForTab} = useContext(themeContext);
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="19"
    //   height="18"
    //   viewBox="0 0 19 18"
    //   fill="none"
    // >
    //   <path
    //     d="M11.461 3.75L15.0835 7.3725V14.25H4.5835V3.75H11.461ZM11.461 2.25H4.5835C3.7585 2.25 3.0835 2.925 3.0835 3.75V14.25C3.0835 15.075 3.7585 15.75 4.5835 15.75H15.0835C15.9085 15.75 16.5835 15.075 16.5835 14.25V7.3725C16.5835 6.975 16.426 6.5925 16.141 6.315L12.5185 2.6925C12.241 2.4075 11.8585 2.25 11.461 2.25ZM6.0835 11.25H13.5835V12.75H6.0835V11.25ZM6.0835 8.25H13.5835V9.75H6.0835V8.25ZM6.0835 5.25H11.3335V6.75H6.0835V5.25Z"
    //     fill={props.active?"white":"#585858"}
    //   />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M9.046 13.5L13.2835 9.2625L12.196 8.175L9.02725 11.3438L7.45225 9.76875L6.3835 10.8375L9.046 13.5ZM5.3335 16.5C4.921 16.5 4.56787 16.3531 4.27412 16.0594C3.98037 15.7656 3.8335 15.4125 3.8335 15V3C3.8335 2.5875 3.98037 2.23438 4.27412 1.94063C4.56787 1.64687 4.921 1.5 5.3335 1.5H11.3335L15.8335 6V15C15.8335 15.4125 15.6866 15.7656 15.3929 16.0594C15.0991 16.3531 14.746 16.5 14.3335 16.5H5.3335ZM10.5835 6.75V3H5.3335V15H14.3335V6.75H10.5835Z"
        // fill={props.active?"white":"#bfbfbf"}
        // fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
        fill={getThemeColorForTab(props.active)}
      />
    </svg>
  );
};

export default ReportedIcon;
